module.exports = __webpack_public_path__ + "img/scjr-tzjg.5acae664.jpg";